import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import "./FuncPrimersContent.css";
import Container from "@material-ui/core/Container";
import FoundationNavBar from "./FoundationNavBar";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
// import { library } from '@fortawesome/fontawesome-svg-core';
// library.add(faAngleDoubleDown);

function FuncPrimersContent() {
  return (
    <div className="main-container foundation-func-container" id="main">
      <title>Foundation - Functional Foundational Primers</title>
      <h1 className="sr-only" tabIndex={0}>
        Foundation - Functional Foundational Primers
      </h1>
      {/* <img src="/images/foundation-banner-v1.jpg" className="banner-img"  alt="Foundation"/> */}
      <img src="/images/Foundation/foundation.png" className="banner-img"  alt="Foundation"/>

      <FoundationNavBar />
      <div className="foundation-phase">
        <p>
          Functional primers lay the business process and domain foundation
          before embarking on to functional competency learnings.
        </p>
      </div>

      <div className="system-eng-container">
        <h2>Platform Delivery</h2>
        <div className="sys-eng-new-wrap">
          <div className="sys-eng-new-row fun-prim-row">
            <div className="sys-eng-new-box">
              <h3>Platform Delivery (Functional)</h3>
              <div className="ess-wrap">
                <span className="plus-symbol">+</span>
                <div className="ess-row">
                  <div className="ess-box box1">
                    <h4>Essentials</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Logic Development
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Software Engineering
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          BA Concepts
                          {/* Generative AI */}
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Requirement Analysis
                          {/* Overview of Business Processes */}
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          BA Technique
                          {/* Agile & DevOps */}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="ess-row">
                  <div className="ess-box box2">
                    <h4>Electives</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Sales Service & Marketing/ CX/CRM
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Manufacturing/ SCM
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          HCM/ HR
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt=""
                            className="arrow-bullet"
                          />{" "}
                          Finance
                        </li>
                      </ul>
                      <p>**Choice based on the skill allocation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="snow-wrap">
          <div className="snow-row">
            <div className="snow-box">
              <h3>Health Primer</h3>
              <ul>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 Logic Development
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 Software Engineering
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 BA Concepts
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 Requirement Analysis
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  BA Technique{" "}
                </li>
                  <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 Healthcare Delivery Providers{" "}
                </li>
                  <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                 Healthcare Marketplace{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>

      {/* <div className="platform-container">
        <div className="platform-wrap">
          <div className="platform-row row1">
            <h2 className="plat-head">Platform Delivery</h2>
            <div className="platform-box">
              <h3>Business and Technology Delivery</h3>
              <ul>
                <li>Logic Development</li>
                <li>Software Engineering</li>
                <li>BA Concepts</li>
                <li>Requirement Analysis</li>
                <li>BA Technique</li>
              </ul>
              <p>45 Hours</p>
            </div>
            <span className="plus-symb">+</span>
            <div className="role-new-box">
              <h3>
                Role based <br /> Functional Primers
              </h3>
              <p>45 Hours</p>
            </div>
            <span className="plus-symb">+</span>
            <h3 className="enhanced">Enhanced C2C</h3>
          </div>
          <div className="platform-row row2">
            <div className="role-based-container">
              <h2 className="role-head">Role based Functional Primers</h2>
              <div className="role-based-wrap wrap1">
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>Sales, Service & Marketing</h3>
                    <ul>
                      <li>Introduction to Sales & Selling Process</li>
                      <li>Customer Engagement</li>
                      <li>Relationship Development</li>
                      <li>Call/Cadence Planning</li>
                      <li>Sales forecasting & Tracking</li>
                      <li>Sales Conversation</li>
                      <li>Opportunity Management</li>
                      <li>Business Development</li>
                      <li>Market Research & Consumer Behavior</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>Manufacturing</h3>
                    <ul>
                      <li>Production Planning & Control</li>
                      <li>Material Requirement Planning</li>
                      <li>Production Lines Development</li>
                      <li>Quality & Const Control</li>
                      <li>Inventory Control</li>
                      <li>Maintenance of Machines</li>
                      <li>Project Manufacturing</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>CX/CRM</h3>
                    <ul>
                      <li>Introduction to CX</li>
                      <li>Introduction to CRM</li>
                      <li>Customer Experience and Marketing</li>
                      <li>Customer Journey Maps</li>
                      <li>Branding</li>
                      <li>CRM Data Handling</li>
                      <li>CRM for Lead Management</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
              </div>

              <div className="role-based-wrap wrap2">
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>HCM/HR</h3>
                    <ul>
                      <li>HR Basics & Managing HR</li>
                      <li>HR Metrics</li>
                      <li>Recruiting</li>
                      <li>Compensation</li>
                      <li>Diversity and Inclusion</li>
                      <li>Performance Management</li>
                      <li>Training</li>
                      <li>Payroll</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>SCM</h3>
                    <ul>
                      <li>Supply Chain Concepts</li>
                      <li>Procurement, Purchasing & Sourcing</li>
                      <li>Manufacturing & Warehousing</li>
                      <li>Transportation & 3rd Party Logistics</li>
                      <li>Sales Order Management</li>
                      <li>Governance and Risk Management</li>
                      <li>Materials Management</li>
                      <li>Inventory Management</li>
                      <li>Compliance with Business Protocols</li>
                      <li>Monitoring Supplier Performance</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
                <div className="role-based-row">
                  <div className="role-based-box">
                    <h3>Finance</h3>
                    <ul>
                      <li>Accounting & Capital Budgeting</li>
                      <li>Financial Audit Financial Closing</li>
                      <li>Financial Strategy & Planning</li>
                      <li>Taxation</li>
                      <li>Treasury Management</li>
                      <li>Regulatory Reporting</li>
                    </ul>
                    <p>45 Hours</p>
                  </div>
                </div>
              </div>
              <h3 className="enhanced">
                <span className="career"></span> Career Track |{" "}
                <span className="job"></span> Job Family |{" "}
                <span className="roles"></span> Role based Functional Primers
              </h3>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default FuncPrimersContent;
